<div class="login-container">
  <!-- Left Section - Login Card -->
  <div class="login-left-section">
    <div class="login-card-wrapper" [class.flipped]="showLoginForm">
      <div class="login-card login-card-front">
        <div class="login-logo">
          <div class="logo-stack">
            <div class="logo-square logo-square-1"></div>
            <div class="logo-square logo-square-2"></div>
            <div class="logo-square logo-square-3"></div>
          </div>
        </div>
        <h1 class="login-title">Bem-vindo ao</h1>
        <h1 class="login-title">{{ projectName }}</h1>
        <p class="login-description">
          Armazenamento centralizado de dados, para descobrir, analisar e manipular seus dados de forma eficiente.
        </p>
        
        <div class="login-form-container">
          <button-induxtry 
            [buttonProperties]="{ label: 'Entrar', customStyle: 'primary', elongated: true }" 
            (action)="flipToLogin()">
          </button-induxtry>
        </div>
      </div>

      <div class="login-card login-card-back">
        <div class="login-form-container">
          @if (isBasicLogin()) {
          <form [formGroup]="form" class="login-form">
            <text-input [textInput]="textInterface" formControlName="email"></text-input>
            <password-input [passwordInput]="passwordInterface" formControlName="password"></password-input>
            <div class="login-actions">
              <button-induxtry 
                [buttonProperties]="{ label: 'Voltar', customStyle: 'secondary', elongated: true }" 
                (action)="flipToWelcome()">
              </button-induxtry>
              <button-induxtry 
                [buttonProperties]="{ label: 'Entrar', customStyle: 'primary', elongated: true }" 
                (action)="handleLoginBasic()">
              </button-induxtry>
            </div>
          </form>
          } @else if (isSAMLLogin()) {
          <button-induxtry 
            [buttonProperties]="{ label: 'Login SAML', customStyle: 'primary', elongated: true }" 
            (action)="handleLoginSAML()">
          </button-induxtry>
          } @else {
          <button-induxtry 
            [buttonProperties]="{ label: 'Login SSO', customStyle: 'primary', elongated: true }" 
            (action)="handleLogin()">
          </button-induxtry>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Right Section - Carousel with Platform Info -->
  <div class="login-right-section">
    <div class="platform-container">
      <app-carousel [slides]="carouselSlides" [autoPlayInterval]="5000"></app-carousel>
    </div>
  </div>
</div>